export default {
    制造实力:'Fertigungsmöglichkeiten',
    产品展示:'Produkte',
    工厂分布:'Produktionsstandorte',
    车身金属:'Metallteile',

    //index
    productList:['IMD Zierteil\nIML Zierteil\nEchtholz Dekorleisten\nZierteile mit Ambient Beleuchtung','Dashboard\nMittelkonsole\nHeadliner\nTürverkleidung\nABC-Säulen\nKopfstütze\nLuftkanal\nLufteinlassgitter\nSpoiler\nTankdeckel','Karosserieteile\nChassis Metallteile\nAnschweißmontage\nAbgassystem','Rückspiegel-System\nElektronisches Steuergerät\nKabelbaum\nBatterieverpackung Verbundenes Geschäft'],
    // productList:['Aluminum\nWood\nIML/IMS','Instrument Panel\nCenter Console\nHeadliner\nDoor Panel\nABC Pillar\nHeadrest\nPanel\nAir Duct & Washing Tank\nAir Inlet Grille\nPedal\nSpoiler\nFuel filler \nBumper\nSide Window ','Bumper\nAnti-Collision Beam\nStructure Parts (Window/Pillar..）\nFuel Tank Panel\nBumper\nMetal baffle\nMetal Base\nSunroof Frame\nHot Forming Product \nLaser welding assembly\nArc welding assembly\nFriction welding assembly','Control Unit\nRear Mirror\nNev Battery Package\nWire Harness'],
    productPisitionList:[['Aluminum'],['Bumper'],['Anti-Collision Beam'],['Rear Mirror']],
    客户:'Kunden',
    优势:'Vorteil',
    产品:'Produkte'
}
